export const expenseTypesSelector = (state) => state.workforceDetail.expenseTypes;
export const expensesSelector = (state) => state.workforceDetail.expenses;
export const paymentMethodsSelector = (state) => state.workforceDetail.paymentMethods;
export const monthSalarySelector = (state) => state.workforceDetail.monthSalary;
export const leaveBalanceSelector = (state) => state.workforceDetail.leaveBalance
export const allBankSelector = (state) => state.workforceDetail.allBanks